import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import { WHITE } from '../../../constants/colors';

export default {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
    margin-bottom: 20px;
  `,

  circle: css`
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    ${media.md`
      width: 30px;
      height: 30px;
    `};
  `,

  stepNumber: css`
  color: ${WHITE};
  font-size: ${rem('13px')};
  `,

  label: css`
    font-size: ${rem('12px')};
    text-align: center;
    margin: 0px !important;
    width: 200px;
    position: absolute;
    font-weight: bold;
    top: 50px;
  `
};
